import EA from '../helpers/init';

export default EA.Methods.teamCardsEqualHeight = ($this) => {
    const cards = $this.querySelectorAll('.team-card');

    function groupCardsByRow() {
        const rows = new Map();

        for (const card of cards) {
            const top = Math.round(card.getBoundingClientRect().top);

            if(!rows.has(top)) {
                rows.set(top, []);
            }

            rows.get(top).push(card);
        }

        return [...rows.values()];
    }

    function resetCardsHeight() {
        cards.forEach(card => {
            card.querySelector('.name').style.minHeight = '';
            card.querySelector('.position').style.minHeight = '';
        });
    }

    function setCardsHeight() {
        const cardRows = groupCardsByRow();

        cardRows.forEach(row => {
            resetCardsHeight();

            setTimeout(() => {
                const nameMaxHeight = Math.max(...row.map(card => card.querySelector('.name').offsetHeight));
                const positionMaxHeight = Math.max(...row.map(card => card.querySelector('.position').offsetHeight));

                row.forEach(card => {
                    card.querySelector('.name').style.minHeight = `${nameMaxHeight}px`;
                    card.querySelector('.position').style.minHeight = `${positionMaxHeight}px`;
                });
            }, 0);
        });
    }

    if(window.innerWidth > 600) {
        setCardsHeight();
    }

    let resizeTimeoutId;

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeoutId);

        if(window.innerWidth > 600) {
            resizeTimeoutId = setTimeout(setCardsHeight, 250);
        } else {
            resetCardsHeight();
        }
    });
};
